<div
    class="d-flex align-items-start justify-content-center py-4"
    style="position: fixed; inset: 0; background-color: #f5f7fa; z-index: 1050; overflow-y: auto"
>
    <div class="p-4" style="max-width: 720px; width: 100%">
        <h2 class="text-center mb-4" style="color: #1a5276; font-weight: bold">VanCon Inc. – Tire Service Request</h2>

        @if (status === 'loading') {
            <div class="text-center">
                <div class="spinner-border text-primary mb-3" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="text-muted">Loading work order details&hellip;</p>
            </div>
        }

        @if (status === 'error') {
            <div class="text-center">
                <h4 class="mb-3">Unable to Load</h4>
                <p>This link is no longer valid or the tire dispatch was not found.</p>
                <p class="text-muted small">If you believe this is an error, please contact VanCon equipment dispatch.</p>
            </div>
        }

        @if (details && status !== 'loading' && status !== 'error') {
            <div class="card mb-3">
                <div class="card-body">
                    <h5 class="card-title">{{ details.vendorName }}</h5>
                    <p class="text-muted mb-3">Status: {{ details.status }}</p>

                    <dl class="row mb-0 small">
                        <dt class="col-sm-4">Equipment</dt>
                        <dd class="col-sm-8">{{ details.equipment }} – {{ details.equipmentDescription }}</dd>
                        <dt class="col-sm-4">Serial / Make</dt>
                        <dd class="col-sm-8">{{ details.serialNumber }} / {{ details.makeModel }}</dd>
                        <dt class="col-sm-4">Usage</dt>
                        <dd class="col-sm-8">{{ details.usage || '—' }}</dd>
                        <dt class="col-sm-4">Job site</dt>
                        <dd class="col-sm-8">{{ details.job }}<br />{{ details.jobAddress }}</dd>
                        <dt class="col-sm-4">Current location</dt>
                        <dd class="col-sm-8">
                            {{ details.locationDescription || '—' }}
                            @if (details.locationMapUrl) {
                                <br />
                                <a [href]="details.locationMapUrl" target="_blank" rel="noopener">Open map pin</a>
                            }
                        </dd>
                        <dt class="col-sm-4">Problem</dt>
                        <dd class="col-sm-8">{{ details.problemType }}</dd>
                        <dt class="col-sm-4">Position</dt>
                        <dd class="col-sm-8">
                            Axle {{ details.axleNumber }} {{ details.side }} – {{ details.resolvedTireSize || '—' }}
                        </dd>
                        @if (details.vendorLocation || details.vendorPhone || details.vendorContactName) {
                            <dt class="col-sm-4">Vendor location</dt>
                            <dd class="col-sm-8">{{ details.vendorLocation || details.vendorName }}</dd>
                            <dt class="col-sm-4">Vendor contact</dt>
                            <dd class="col-sm-8">
                                {{ details.vendorContactName || '—' }}
                                @if (details.vendorPhone) {
                                    – {{ details.vendorPhone }}
                                }
                            </dd>
                        }
                        <dt class="col-sm-4">Field contact</dt>
                        <dd class="col-sm-8">{{ details.submitterName }} – {{ details.submitterPhone }}</dd>
                    </dl>

                    @if (details.allAxleSizes.length) {
                        <div class="mt-3">
                            <strong class="small">All tire sizes on machine</strong>
                            <ul class="small mb-0">
                                @for (row of details.allAxleSizes; track row.axleNumber + row.side) {
                                    <li>
                                        Axle {{ row.axleNumber }} {{ row.side }}: {{ row.tireSize }}
                                        @if (row.positionLabel) {
                                            <span class="text-muted">({{ row.positionLabel }})</span>
                                        }
                                    </li>
                                }
                            </ul>
                        </div>
                    }

                    @if (details.damageImageUrls.length) {
                        <div class="mt-3 d-flex flex-wrap gap-2">
                            @for (url of details.damageImageUrls; track url) {
                                <a [href]="url" target="_blank" rel="noopener">
                                    <img [src]="url" alt="Damage" style="max-height: 100px; max-width: 140px" />
                                </a>
                            }
                        </div>
                    }
                </div>
            </div>

            @if (status === 'ready') {
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Confirm receipt</h5>
                        <p class="text-muted small">Please confirm you received this request and provide an estimated response time.</p>

                        <div class="form-check mb-3">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                id="declined"
                                [(ngModel)]="declined"
                                name="declined"
                            />
                            <label class="form-check-label" for="declined">Unable to service (decline)</label>
                        </div>

                        @if (!declined) {
                            <div class="mb-3">
                                <label for="responseEta" class="form-label">Estimated response / arrival time</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="responseEta"
                                    name="responseEta"
                                    [(ngModel)]="responseEta"
                                    placeholder="e.g. Today by 3pm, tomorrow AM"
                                />
                            </div>
                        }

                        <div class="mb-3">
                            <label for="notes" class="form-label">Notes (optional)</label>
                            <textarea class="form-control" id="notes" name="notes" rows="2" [(ngModel)]="notes"></textarea>
                        </div>

                        @if (submitStatus === 'error') {
                            <p class="text-danger small">Failed to submit. Please try again.</p>
                        }

                        <button
                            type="button"
                            class="btn btn-primary"
                            (click)="submitResponse()"
                            [disabled]="submitStatus === 'submitting' || (!declined && !responseEta.trim())"
                        >
                            @if (submitStatus === 'submitting') {
                                <span class="spinner-border spinner-border-sm me-2"></span>
                            }
                            Submit
                        </button>
                    </div>
                </div>
            }

            @if (status === 'submitted') {
                <div class="alert alert-success">
                    @if (declined) {
                        Thank you — your decline has been recorded.
                    } @else {
                        Thank you — your response has been recorded.
                    }
                </div>

                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Upload receipt (optional)</h5>
                        <p class="text-muted small">Upload invoice or receipt for accounting matching.</p>
                        <input type="file" accept="image/*,.pdf" multiple (change)="onReceiptSelected($event)" class="form-control mb-2" />
                        @if (receiptUploadStatus === 'error') {
                            <p class="text-danger small">Upload failed. Please try again.</p>
                        }
                        @if (receiptUploadStatus === 'done') {
                            <p class="text-success small">Receipt uploaded. Thank you!</p>
                        }
                        <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            (click)="uploadReceipt()"
                            [disabled]="!receiptFiles.length || receiptUploadStatus === 'uploading'"
                        >
                            Upload receipt
                        </button>
                    </div>
                </div>

                <p class="text-muted text-center mt-3 small">You may close this page.</p>
            }
        }
    </div>
</div>
